import { Instagram, ChevronUp } from "lucide-react";
import { Link } from "react-router-dom";

// TikTok Icon Component
const TikTokIcon = ({ size = 20, className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    className={className}
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_coach-reserve-2/artifacts/ba2pyiiu_E8675A27-AB74-4AD8-A47C-0CC6F6A992C1.PNG" 
              alt="Aktas Personal Fussballtraining Logo"
              className="h-10 w-10 object-contain"
            />
            <div>
              <p className="font-['Bebas_Neue'] text-lg text-white leading-tight">
                YASIN AKTAS PERSONAL FUSSBALLTRAINING
              </p>
            </div>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            <a
              href="https://instagram.com/fussballtraining_aktas"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#A1A1AA] hover:text-[#c1ff72] transition-colors duration-300"
              data-testid="footer-instagram"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://tiktok.com/@fussballtraining_aktas"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#A1A1AA] hover:text-[#c1ff72] transition-colors duration-300"
              data-testid="footer-tiktok"
            >
              <TikTokIcon size={20} />
            </a>
            <button
              onClick={scrollToTop}
              className="w-10 h-10 bg-[#1A1A1A] border border-white/10 flex items-center justify-center hover:border-[#c1ff72] hover:bg-[#c1ff72]/10 transition-all duration-300"
              data-testid="scroll-to-top-button"
            >
              <ChevronUp className="w-5 h-5 text-white" />
            </button>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#71717A] text-sm">
            © {currentYear} Fußballakademie Aktas. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link to="/meine-termine" className="text-[#A1A1AA] hover:text-[#c1ff72] text-sm transition-colors" data-testid="footer-meine-termine">Meine Termine</Link>
            <Link 
              to="/impressum" 
              className="text-[#A1A1AA] hover:text-[#c1ff72] text-sm transition-colors"
              data-testid="footer-impressum"
            >
              Impressum
            </Link>
            <Link 
              to="/datenschutz" 
              className="text-[#A1A1AA] hover:text-[#c1ff72] text-sm transition-colors"
              data-testid="footer-datenschutz"
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
